import { keyframes } from "styled-components";

const RollFromBottom = props => {
  if (props.percentage) {
    switch (props.percentage) {
      case "1":
        return keyframes`
      0% {
        transform: translateY(60%);
        opacity: 0;
      }
      100% {
        transform: translateY(0)
        opacity: 1;
      }
    `;
      case "2":
        return keyframes`
      0% {
        transform: translateY(120%);
        opacity: 0;
      }
      100% {
        transform: translateY(150%)
        opacity: 1;
      }
    `;
      default:
        break;
    }
  }
  return keyframes`
      0% {
        transform: translateY(60%);
        opacity: 0;
      }
      100% {
        transform: translateY(0)
        opacity: 1;
      }
      `;
};

export default RollFromBottom;
